import { Helmet } from "react-helmet-async";
import GetStartedFreeTrial from "../../components/GetStartedFreeTrial";
import HeroSection from "../../components/HeroSection";
import '../../styles/Features.css';

const exploreFeatures = [
    {
        number: "01",
        name: "Fleet Management Software for Rental Businesses",
        description:
            "Manage and monitor your entire vehicle fleet from a centralized fleet management system. Track availability, vehicle condition, and location in real time to maximize utilization and reduce operational downtime."
    },
    {
        number: "02",
        name: "Real-Time Vehicle Tracking & GPS Monitoring",
        description:
            "Gain full visibility into your rental fleet with real-time GPS vehicle tracking. Monitor vehicle locations, usage, and movement to improve safety, optimize logistics, and ensure timely pickups and returns."
    },
    {
        number: "03",
        name: "Automated Vehicle Booking & Reservation System",
        description:
            "Allow customers to book vehicles online with an automated reservation system built for rental businesses. Manage availability, pricing, confirmations, and notifications while preventing double bookings."
    },
    {
        number: "04",
        name: "Customizable Rental Pricing & Plans",
        description:
            "Create flexible rental plans by customizing pricing, rental duration, and terms based on vehicle type, location, and customer segments. Adapt quickly to seasonal demand and business needs."
    },
    {
        number: "05",
        name: "Automated Invoicing & Secure Payments",
        description:
            "Streamline billing with automated invoice generation based on rental duration, vehicle type, and usage. Accept multiple payment methods and maintain accurate financial records with ease."
    },
    {
        number: "06",
        name: "Vehicle Maintenance & Service Management",
        description:
            "Keep your fleet rental-ready with maintenance and service tracking. Receive automated alerts for scheduled servicing, track maintenance history, and reduce breakdowns to ensure reliable rentals."
    },
];


const Features = () => {
    return (
        <div>
            <Helmet>
                <title>Vehicle Rental Management Software Features | RD Rental</title>
                <meta
                    name="description"
                    content="Explore powerful vehicle rental management software features including fleet management, real-time tracking, automated bookings, maintenance, and reporting."
                />
            </Helmet>

            <HeroSection
                mainHeading="Vehicle Rental Management Software Features"
                subHeading="Everything You Need to Manage, Track, and Scale Your Rental Business"
                backgroundImage="../images/features-rd-rental.png"
            />

            <section className="feature-section">
                <div className="text-container">
                    <h1 className="headline">
                        Powerful Features Built for Vehicle Rental Businesses
                    </h1>
                </div>

                <div className="feature-row">
                    <div className="feature-text">
                        <h2 className="feature-title">
                            Fleet Management Software for Rental Businesses
                        </h2>
                        <p className="feature-description">
                            Manage cars, vans, and trucks from a single dashboard. Track vehicle availability,
                            condition, and usage in real time while scheduling maintenance and reducing downtime.
                            RD Rental helps maximize fleet utilization and rental revenue.
                        </p>
                    </div>

                    <div className="feature-image">
                        <img src="../images/rd-rental-feature-1.png" alt="fleet management software dashboard for vehicle rental businesses" />
                    </div>
                </div>

                <div className="feature-row">
                    <div className="feature-image">
                        <img src="../images/rd-rental-feature-2.png" alt="real-time vehicle tracking software for rental fleet" />
                    </div>

                    <div className="feature-text">
                        <h2 className="feature-title">
                            Real-Time Vehicle Tracking & Usage Monitoring
                        </h2>
                        <p className="feature-description">
                            Track vehicle locations, mileage, and usage patterns with real-time GPS tracking.
                            Improve logistics, reduce fuel costs, prevent misuse, and ensure on-time pickups
                            and returns for a better rental experience.
                        </p>
                    </div>
                </div>
            </section>

            <section className="features-section-box">
                <div className="features-container-box">
                    <h2 className="features-heading-box">
                        Complete Vehicle Rental Management System Features
                    </h2>

                    <div className="features-list-box">
                        {exploreFeatures.map((item, index) => (
                            <div key={index} className="feature-item-box">
                                <div className="feature-content-box">
                                    <span className="feature-number-box">
                                        {item.number}
                                    </span>
                                    <h3 className="feature-name-box">
                                        {item.name}
                                    </h3>
                                    <p className="feature-description-box">
                                        {item.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <GetStartedFreeTrial />
        </div>
    );
};

export default Features;